import React from 'react';
import { Typography } from 'fronton-react';
import { EridTokenCoping } from 'common/components';
import { Ord } from 'api/placements-api';
import { IconButtonVariant } from 'fronton-react/button/icon-button/types';

interface AdDataProps {
  ord?: Ord;
  className?: string;
  variantEridColor?: IconButtonVariant;
}
/**
 * @description Общий компонент-всплывашка с информацией из ОРД. Используется в баннерах и в карусели баннеров
 * @param ord - данные о рекламодателе
 * @param className
 * @param variantEridColor
 */
export const AdData: React.FC<AdDataProps> = ({ ord, className, variantEridColor }) => {
  return (
    <div data-qa="ad-label-legal-data" className={className}>
      {ord?.advertiser.legalName && (
        <Typography variant="s" size="body_long">
          {ord.advertiser.legalName}
        </Typography>
      )}

      {ord?.advertiser.inn && (
        <Typography variant="s" size="body_long">
          ИНН {ord.advertiser.inn}
        </Typography>
      )}

      {ord?.advertiser.ogrn && (
        <Typography variant="s" size="body_long">
          ОГРН {ord.advertiser.ogrn}
        </Typography>
      )}
      {ord?.eridToken && <EridTokenCoping eridToken={ord.eridToken} variant={variantEridColor} />}
    </div>
  );
};
